import confetti from "canvas-confetti";

const COLORS = ["#FF5D1F", "#FFE600", "#FF2A85", "#00E5FF", "#7C3AED", "#10B981"];

export function isLowPowerDevice(): boolean {
  const nav = navigator as any;
  return (nav.hardwareConcurrency && nav.hardwareConcurrency <= 2) || (nav.deviceMemory && nav.deviceMemory <= 2);
}

export function systemPrefersReducedMotion(): boolean {
  return typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
}

export function burst() {
  confetti({ particleCount: 90, spread: 80, startVelocity: 45, origin: { y: 0.45 }, colors: COLORS, scalar: 1.1, zIndex: 80 });
}

export function vibrate(ms = 30) {
  try {
    navigator.vibrate?.(ms);
  } catch {
    /* unsupported */
  }
}
